define(["angular",
    "angular-simple-logger",
    "../maps/mapsModule",
    "../toll/toll",
    "../externalFreight/externalFreight",
    "../cancellation/cancellation",
    "../optimization/optimization",
    "../moveTripsToUser/moveTripsToUser",
    "../moveToAnotherUser/moveToAnotherUser",
    "../tripPickingList/tripPickingList",
    "../tripOperationHistory/tripOperationHistory",
], function (angular) {
    "use strict";

    return angular.module("nodeCommandsModule", [
        "mapsModule",
        "tollModule",
        "externalFreightModule",
        "commonsCancellationModule",
        "commonsOptimizationModule",
        "moveTripsToUserModule",
        "moveToAnotherUserModule",
        "arrangementModule",
        "tripPickingListModule",
        "tripOperationHistoryModule",
    ]);
});